import { render, staticRenderFns } from "./FeatureList.vue?vue&type=template&id=15867f5a&scoped=true&"
import script from "./FeatureList.vue?vue&type=script&lang=js&"
export * from "./FeatureList.vue?vue&type=script&lang=js&"
import style0 from "./FeatureList.vue?vue&type=style&index=0&id=15867f5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15867f5a",
  null
  
)

export default component.exports